import React from "react";
import { KpiCard, Panel } from "@/pages/dashboard/widgets";
import { inr } from "@/lib/dashboard";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

export default function InventoryView({ data }) {
  if (!data) return null;
  return (
    <div className="space-y-6" data-testid="inventory-view">
      <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
        <KpiCard testid="inv-kpi-available" label="Available" value={`${data.available_items ?? 0}`} sub={`${data.available_meters ?? 0} m`} accent="text-emerald-600" />
        <KpiCard testid="inv-kpi-reserved" label="Reserved" value={`${data.reserved_items ?? 0}`} sub={`${data.reserved_meters ?? 0} m`} accent="text-amber-600" />
        <KpiCard testid="inv-kpi-ready" label="Dispatch-ready" value={data.dispatch_ready_items ?? 0} accent="text-indigo-600" />
        <KpiCard testid="inv-kpi-valuation" label="Finished stock value" value={inr(data.valuation)} accent="text-slate-900" />
      </div>
      {(data.raw_material_value !== undefined) && (
        <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
          <KpiCard testid="inv-kpi-rm-value" label="Raw material value" value={inr(data.raw_material_value)} accent="text-emerald-600" />
          <KpiCard testid="inv-kpi-rm-low" label="Raw materials low" value={data.raw_material_low ?? 0} accent="text-rose-600" />
        </div>
      )}
      <Panel title={`Low-remnant rolls (${data.low_stock_count ?? 0})`}>
        <div className="overflow-x-auto">
          <Table>
            <TableHeader><TableRow className="bg-slate-50">
              <TableHead className="text-xs uppercase text-slate-500">Item</TableHead>
              <TableHead className="text-xs uppercase text-slate-500">Customer</TableHead>
              <TableHead className="text-right text-xs uppercase text-slate-500">Meters left</TableHead>
            </TableRow></TableHeader>
            <TableBody>
              {(data.low_stock || []).map((it) => (
                <TableRow key={it.item_no} data-testid={`inv-low-${it.item_no}`}>
                  <TableCell className="font-medium text-slate-800">{it.item_no}</TableCell>
                  <TableCell className="text-slate-600">{it.customer || "—"}</TableCell>
                  <TableCell className="text-right tabular-nums text-rose-600">{it.meters} m</TableCell>
                </TableRow>
              ))}
              {(data.low_stock || []).length === 0 && <TableRow><TableCell colSpan={3} className="py-8 text-center text-slate-400">No low-remnant rolls.</TableCell></TableRow>}
            </TableBody>
          </Table>
        </div>
      </Panel>
    </div>
  );
}
